import React from "react";
import { QuoteIcon, StarIcon } from "lucide-react";
import { featuredTestimonial, testimonials } from "../../data/content";
import { SectionCta } from "../SectionCta";
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-288" data-mp="3mgisgcdnoo11">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-cta text-cta" aria-hidden="true" data-id="element-289" data-mp="3r8k9scpol4xx" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  return <section className="bg-mist px-5 py-16 sm:py-20" data-id="element-290" data-mp="42t2rb9y6roi">
      <div className="mx-auto max-w-5xl" data-id="element-291" data-mp="41i2hlfpo225">
        <p className="font-display text-sm font-extrabold uppercase tracking-wide text-brand" data-id="element-292" data-mp="91w8kxxr51xj">What professionals look for in renal nutrition education</p>
        <h2 className="mt-3 font-display text-3xl font-black uppercase leading-[1.08] text-ink sm:text-4xl" data-id="element-293" data-mp="dznwlgva03wg">A structured approach to professional learning</h2>

        <figure className="mt-10 overflow-hidden rounded-3xl bg-ink text-white md:grid md:grid-cols-[0.8fr_1.2fr]" data-id="element-294" data-mp="2fs3waoxosydp">
          <img src={featuredTestimonial.photo} alt={featuredTestimonial.name} className="aspect-square w-full object-cover md:aspect-auto md:h-full" data-id="element-295" data-mp="1skssjvb4ayoj" />
          <div className="p-6 sm:p-8" data-id="element-296" data-mp="1nrq1puxq63c1">
            <QuoteIcon className="h-9 w-9 text-cta" aria-hidden="true" data-id="element-297" data-mp="1ity7gu9ly54o" />
            <blockquote className="mt-4 text-lg font-medium leading-relaxed sm:text-xl" data-id="element-298" data-mp="1et4l45btcydw">“{featuredTestimonial.quote}”</blockquote>
            <figcaption className="mt-6" data-id="element-299" data-mp="2bjnbzhlj0nb1">
              <Stars data-id="element-300" data-mp="2bilvgxlqr8lx" />
              <p className="mt-2 font-display text-lg font-black uppercase" data-id="element-301" data-mp="26kanytix5a6v">{featuredTestimonial.name}</p>
              <p className="text-sm text-white/70" data-id="element-302" data-mp="22igq0t03ykae">{featuredTestimonial.role}</p>
            </figcaption>
          </div>
        </figure>

        <div className="mt-6 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-303" data-mp="1xikod0evv4y0">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-6" data-id="element-304" data-mp="r54tz4alb5ys">
              <Stars data-id="element-305" data-mp="m3fk3rz3syca" />
              <h3 className="mt-3 font-display text-lg font-black uppercase leading-tight text-ink" data-id="element-306" data-mp="m35onovahyz7">“{t.title}”</h3>
              <blockquote className="mt-3 text-[15px] leading-relaxed text-muted" data-id="element-307" data-mp="njjm4wya7yal">{t.body}</blockquote>
              <figcaption className="mt-auto flex items-center gap-3 border-t border-line pt-5" data-id="element-308" data-mp="sicyun5qvl9p">
                <img src={t.photo} alt={t.name} className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-cta" data-id="element-309" data-mp="enaif639udin" />
                <div data-id="element-310" data-mp="4vejjstd2jdd">
                  <p className="font-bold text-ink" data-id="element-311" data-mp="4u3gxwbnjhnu">{t.name}</p>
                  <p className="text-sm text-muted" data-id="element-312" data-mp="9luyjhctyd1u">{t.role}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <SectionCta heading="Join the professionals organizing their renal nutrition study" label="I want my Blueprint" data-id="element-313" data-mp="3r3xnmgivd7tn" />
      </div>
    </section>;
}